import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./_dropdown-menu.module.css";

const LazyLabel = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { Label } = await import("@radix-ui/react-dropdown-menu");

	return { default: Label };
});

export type DropdownMenuLabelProps = React.ComponentProps<typeof LazyLabel>;

export const DropdownMenuLabel = React.forwardRef<React.ComponentRef<typeof LazyLabel>, DropdownMenuLabelProps>(
	({ className, ...props }, ref) => <LazyLabel className={cx(styles.label, className)} ref={ref} {...props} />,
);

if (import.meta.env.DEV) {
	DropdownMenuLabel.displayName = "DropdownMenuLabel";
}
